import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const TemplateCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateCategories"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TemplateCategories","document":TemplateCategoriesDocument}} as const;
export type TemplateCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TemplateCategoriesQuery = (
  { __typename: 'Query' }
  & { templateCategories: Array<(
    { __typename: 'TemplateCategory' }
    & Pick<Types.TemplateCategory, 'key'>
  )> }
);

/**
 * __useTemplateCategoriesQuery__
 *
 * To run a query within a React component, call `useTemplateCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTemplateCategoriesQuery(
  baseOptions?: TrelloQueryHookOptions<
    TemplateCategoriesQuery,
    TemplateCategoriesQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: TemplateCategoriesDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    TemplateCategoriesQuery,
    TemplateCategoriesQueryVariables
  >(TemplateCategoriesDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useTemplateCategoriesLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    TemplateCategoriesQuery,
    TemplateCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TemplateCategoriesQuery,
    TemplateCategoriesQueryVariables
  >(TemplateCategoriesDocument, options);
}
export function useTemplateCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        TemplateCategoriesQuery,
        TemplateCategoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TemplateCategoriesQuery,
    TemplateCategoriesQueryVariables
  >(TemplateCategoriesDocument, options);
}
export type TemplateCategoriesQueryHookResult = ReturnType<
  typeof useTemplateCategoriesQuery
>;
export type TemplateCategoriesLazyQueryHookResult = ReturnType<
  typeof useTemplateCategoriesLazyQuery
>;
export type TemplateCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useTemplateCategoriesSuspenseQuery
>;
export type TemplateCategoriesQueryResult = Apollo.QueryResult<
  TemplateCategoriesQuery,
  TemplateCategoriesQueryVariables
>;
